// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__GhzUR","spin":"Spinner_spin__3XG0h","container":"Spinner_container__216oW"};